import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Paper, Typography, TextField, Button, Container, FormLabel } from "@material-ui/core";
import useStyles from "./styles.js";
import emailjs from "emailjs-com";
require("dotenv").config();

const Contact = () => {
    const classes = useStyles();
    const [formData, setFormData] = useState({ name: "", email: "", message: "" });
    const [formSent, setFormSent] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs.send(
            process.env.REACT_APP_EMAIL_SERVER_ID,
            process.env.REACT_APP_EMAIL_TEMPLATE_ID,
            formData,
            process.env.REACT_APP_EMAIL_API
        );
        setFormData({ name: "", email: "", message: "" });
        window.scrollTo(0, 0);
        setFormSent(true);
    };

    return (
        <Container className={classes.container}>
            <Typography variant="h6" className={classes.contact}>
                {formSent
                    ? "Your response has been recorded. Thank you!"
                    : "Want to know more about our research? Feel free to contact us and one of our team members will get back to you soon!"}
            </Typography>
            <Paper className={classes.paper}>
                <form
                    autoComplete="off"
                    className={classes.form}
                    onSubmit={handleSubmit}
                    title="Contact Us"
                >
                    <p className={classes.formLabel}>Contact Us</p>
                    <TextField
                        className={classes.formField}
                        name="name"
                        variant="standard"
                        label="Name"
                        fullWidth
                        value={formData.name}
                        required
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                    <TextField
                        className={classes.formField}
                        name="email"
                        variant="standard"
                        label="Email"
                        fullWidth
                        value={formData.email}
                        type="email"
                        required
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    />
                    <TextField
                        className={classes.formField}
                        name="message"
                        variant="standard"
                        label="Message"
                        value={formData.message}
                        fullWidth
                        required
                        multiline
                        onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    />
                    <div className={classes.buttonSubmitContainer}>
                        <Button
                            className={classes.buttonSubmit}
                            variant="contained"
                            size="large"
                            type="submit"
                            fullWidth
                        >
                            Submit
                        </Button>
                    </div>
                </form>
            </Paper>
        </Container>
    );
};

export default Contact;
